import React from 'react';

function userHasRole(userRoles, role) {
    let roles = role.split("|");
    let result = false;
    roles.map(function (role) {
        if (userRoles[role] != undefined) {
            result = true;
            return true;
        }
    });
    return result;
}

function userHasPermission(userRoles, allPermissions, permission) {
    //todo delete staff
    if (userRoles['admin'] != undefined || (userRoles['staff'] != undefined && permission == "dashboard_login")) {
        return true;
    }
    let permissions = permission.split("|");
    let result = false;
    permissions.map(function (permission) {
        if (allPermissions[permission] != undefined) {
            result = true;
            return true;
        }
    });
    return result;
}

function getAuthUserInfo(){
    return JSON.parse(sessionStorage.getItem('userInfo'));
}

class ACL extends React.Component {

    constructor(props) {
        super(props);
        let userInfo = getAuthUserInfo();
        this.state = {
            roles: userInfo ? ( userInfo.roles ? userInfo.roles : {} ) : {},
            permissions: userInfo ? ( userInfo.permissions ? userInfo.permissions : {} ) : {}
        };
    }

    hasRole(role) {
        return userHasRole(this.state.roles, role);
    }

    hasPermission(permission) {
        return userHasPermission(this.state.roles, this.state.permissions, permission);
    }

    filter() {
        let children = [];
        if (this.props.children.map == undefined) {
            return this.props.children;
        }
        let _this = this;
        this.props.children.map((child)=> {
            switch (true) {
                case child.props.has_role == undefined && child.props.has_permission == undefined:
                case child.props.has_role != undefined && _this.hasRole(child.props.has_role):
                case child.props.has_permission != undefined && _this.hasPermission(child.props.has_permission):
                    children[children.length] = child;
                    break;
            }

        });
        return children;
    }

    render() {
        const ParentComponent = this.props.component;
        let parentProps = {};
        for (let name in this.props) {
            if(name === "has_permission" && !this.hasPermission(this.props.has_permission)){
                console.log('this.props.denied', this.props.denied);
                return this.props.denied ? this.props.denied() : '';
            }
            if (name !== "component" && name !== "has_role" && name !== "has_permission") {
                parentProps[name] = this.props[name];
            }
        }

        return (
            <ParentComponent {...parentProps}>
                {this.filter()}
            </ParentComponent>
        );

    }
}

export default ACL;

export {
    ACL,
    userHasRole,
    userHasPermission,
    getAuthUserInfo
}


// WEBPACK FOOTER //
// ./src/components/ACL/index.js